import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Colors',
  attributeName: 'parms',
  fields: [
    {
      attributeName: 'roomColor',
      helpText: 'The general color of the room. if you setup this color first, the XMS calculate the rest of the colors.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Room Color',
    },
    {
      attributeName: 'clearColors',
      type: FormInputTypes.BUTTON_FORM,
      mode:'button',
      label: 'Clear colors',
      confirm:true,
      actionUrl:'customization-clear',
      title:"Are you sure you want to clear all colors?",
      description:"You are about to clear the hole set of customization colors for this sportroom",
      className:'ml-3 float-left'
    },
    {
      attributeName: 'extendColors',
      type: FormInputTypes.BUTTON_FORM,
      mode:'button',
      label: 'Extend colors',
      confirm:true,
      actionUrl:'customization-extend',
      title:"Are you sure you want to extend colors?",
      description:"You are about to generate the hole set of colors based on the Room color established. This process will replace the current values for all the colors in this form",
      actionUrl:'customization-extend',
      className:'ml-3 float-left'
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'contentNavigationBarColor',
      helpText: 'There is an underline bar that indicates the state of the button in the navigation bar. The color of the bar changes depending on the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Category Bar color',
    },
    {
      attributeName: 'contentNavigationBarTextColor',
      helpText: 'There is an underline bar that indicates the state of the button in the navigation bar. The color of the bar changes depending on the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Category Bar Text Color',
    },
    {
      attributeName: 'videoPosterHoverColor',
      helpText: 'The content category on hover has an animated colored stroke. This color will change according to the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Video Poster Hover Color',
      isGradient:true,
    },
    {
      attributeName: 'highlightedContentColor',
      helpText: 'The Sport Room panel on hover has an animated colored stroke.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Highlighted Content Color',
      isGradient:true,
    },
    {
      attributeName: 'extendedInfoColor',
      helpText: 'The color of the date subtitle of live events changes depending on the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Extended info Color',
    },
    {
      attributeName: 'buttonsColor',
      helpText: 'Buttons background color change depending on the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Buttons Color',
    },
    {
      attributeName: 'buttonsTextColor',
      helpText: 'Button text color can be chosen also from the XMS. *The XMs could maybe give some suggestions of optimal contrast between text and background legibility.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Buttons Text Color',
    },
    {
      attributeName: 'tagsColor',
      helpText: 'Tags color change depending on the accent color of each Room.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Tags Color',
    },
    {
      attributeName: 'tagsTextColor',
      helpText: 'Tags text color can be chosen also from the XMS. *The XMs could maybe give some suggestions of optimal contrast between text and background legibility.',
      type: FormInputTypes.COLOR_PICKER,
      label: 'Tags Text Color',
    },
  ],
};
